// External
import { Component, OnInit, Input, Renderer2, ElementRef, OnChanges, HostListener, Output, EventEmitter } from '@angular/core';

// Internal
const animationSpeed = 250;

@Component({
    selector: 'drawer',
    template: `<div class="drawer-content" [style.width.px]="width" *ngIf="open"><ng-content></ng-content></div>`,
    host: {
        '[class.open]': 'open',
        '[style.flexBasis.px]': 'open ? width : 0',
        '[tabindex]': 'open ? 0 : -1',
    }
})

export class DrawerComponent implements OnInit, OnChanges {

    @Input() mode: string = 'over'; /// available modes push, side, over
    @Input() position: string = 'left'; /// available positions left & right so far (maybe someday top & bottom will be required)
    @Input() width: number = 280; 

    // [(open)], [open], (openChange) = ng model
    @Input() open: boolean = false;
    @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    
    // initial layout states
    initialMode = this.mode;
    initialPosition = this.position;

    constructor(private renderer: Renderer2, private el: ElementRef) { }

    ngOnInit() {
        this.renderer.addClass(this.el.nativeElement, 'drawer');            
        this.renderer.addClass(this.el.nativeElement, this.mode); 
        this.renderer.addClass(this.el.nativeElement, this.position);          
        this.focusDrawer();
        // this.open ? this.renderer.addClass(this.el.nativeElement, 'open') : this.renderer.removeClass(this.el.nativeElement, 'open');
        // this.el.nativeElement.style.flexBasis = this.open ? this.width + 'px' : '0px';        
    }

    ngOnChanges() {
        this.updateDrawer();
    }

    updateDrawer = () => {
        if(this.mode !== this.initialMode) {            
            this.renderer.removeClass(this.el.nativeElement, this.initialMode);
            this.renderer.addClass(this.el.nativeElement, this.mode);
            this.initialMode = this.mode;
        }

        if (this.position !== this.initialPosition) {
            this.renderer.removeClass(this.el.nativeElement, this.initialPosition);
            this.renderer.addClass(this.el.nativeElement, this.position);   
            this.initialPosition = this.position;
        }

        this.focusDrawer();

        // this.open ? this.renderer.addClass(this.el.nativeElement, 'open') : this.renderer.removeClass(this.el.nativeElement, 'open');
        // this.el.nativeElement.style.flexBasis = this.open ? this.width + 'px' : '0px';        
    }

    // Dismiss on escape, only if focus is in drawer and drawer is 'over' mode
    @HostListener('keydown.escape', ['$event']) onKeydownHandler(event) {
        if(this.open && this.mode === 'over') {
            this.openChange.emit(!this.open);
            this.el.nativeElement.blur();
        }
    }

    focusDrawer(){
        if (this.open) {
            setTimeout(()=> {this.el.nativeElement.focus()}, animationSpeed);
        }
    }

}
